import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

// import { useState } from 'react';
// import Popup4868 from '@/components/ui/4868Popup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Irs2File = () => {
  // const [open, setOpen] = useState(false);
  const [referralUrl, SetReferralUrl] = useState('click2file');

  useEffect(() => {
    const isIRSPageReferral = document.referrer === 'https://www.irs.gov/';
    if (isIRSPageReferral) SetReferralUrl('click2fileirs');
  }, []);
  const [activeTab, setActiveTab] = useState(2);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS2File: File Smarter, Skip Manual Entry | TaxZerone"
          description="Skip manual entry. Use TaxZerone's IRS2File feature to securely import IRS records, pre-fill prior-year financial data, and e-file your taxes in minutes."
          keywords=""
          canonical="features/irs2file/"
        />
      }
    >
      <Box
        sx={{
          mt: 0,
          pt: 8,
          pb: 8,
          position: 'relative',
          background: `
  linear-gradient(180deg,rgba(34, 62, 152, 0.32) 0%, rgba(243, 113, 40, 0.08) 66%, rgba(255, 255, 255, 0.34) 97%)
`,
          overflow: 'hidden',
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            alignContent: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              mt: 4,
              mb: 4,
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 30,
                  md: 38,
                  lg: 48,
                  xl: 56,
                },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              Skip the Manual Entry -
              <span className="highlight-container">
                <span className="highlight"> File Smarter with IRS2File</span>
              </span>{' '}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 16,
                  md: 18,
                  lg: 18,
                },
                fontWeight: 'normal',
                mb: 4,
                // color: '#5b6472',
                lineHeight: 1.5,
                maxWidth: 900,
                mx: 'auto',
              }}
            >
              Automatically import your official IRS records and prior-year
              financial data directly into your return - so your organization
              files accurately and on time.
            </Typography>

            <Stack
              direction={{ xs: 'column-reverse', md: 'row' }}
              spacing={{ xs: 1, md: 6 }}
              justifyContent="center"
              alignItems="center"
              sx={{ mt: 4 }}
            >
              <Button
                variant="contained"
                className="btn-primary"
                sx={{
                  backgroundColor: '#1e2f8f',
                  color: '#ffffff',
                  fontWeight: 500,
                  fontSize: 16,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  boxShadow: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover, &:focus, &:active': {
                    backgroundColor: '#16247a',
                    transform: 'scale(1.05)',
                  },
                }}
                href="#compare"
              >
                Compare Now
              </Button>

              <Stack
                direction="row"
                spacing={2}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
              >
                <Box
                  sx={{
                    mb: { xs: '0 !important', md: '0px !important' },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/irs-authorized.webp" />
                    <source srcSet="/assets/images/irs-authorized.png" />
                    <Box
                      component="img"
                      src="/assets/images/irs-authorized.png"
                      loading="lazy"
                      alt="IRS-authorized e-file provider"
                      width={70}
                      height={69}
                      sx={{
                        width: { xs: 50, md: 70 },
                        height: { xs: 49, md: 69 },
                      }}
                    />
                  </picture>
                </Box>
                <Box
                  sx={{
                    mb: { xs: '0px !important', md: '0px !important' },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/ftb-logo.webp" />
                    <source srcSet="/assets/images/ftb-logo.png" />
                    <Box
                      component="img"
                      src="/assets/images/ftb-logo.png"
                      loading="lazy"
                      alt="TZO FTB Logo"
                      width={80}
                      height={80}
                      sx={{
                        width: { xs: 70, md: 80 },
                        height: { xs: 70, md: 80 },
                      }}
                    />
                  </picture>
                </Box>
                <Box
                  sx={{
                    mb: { xs: '0px !important', md: '0px !important' },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/tzo-soc2.webp" />
                    <source srcSet="/assets/images/tzo-soc2.png" />
                    <Box
                      component="img"
                      src="/assets/images/tzo-soc2.png"
                      loading="lazy"
                      alt="TZO SOC2 Compliant"
                      width={90}
                      height={89}
                      sx={{
                        width: { xs: 70, md: 90 },
                        height: { xs: 69, md: 89 },
                      }}
                    />
                  </picture>
                </Box>
              </Stack>
            </Stack>
            <Stack
              spacing={2}
              justifyContent="center"
              alignItems="center"
              sx={{
                mt: '55px !important',
                mb: { xs: '116px !important', sm: '16px !important' },
              }}
            >
              <Box
                sx={{
                  width: { xs: 300, sm: 600 },
                  height: 80,
                  // boxShadow:
                  //   '  2px 0 3px rgba(0, 0, 0, 0.15),  -1px 0 2px rgba(255, 255, 255, 0.8)',
                }}
              >
                <Grid container spacing={1} sx={{ mt: 0, mb: 4 }}>
                  <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                    <Stack
                      direction={{ xs: 'row', sm: 'row' }}
                      spacing={1}
                      alignItems="center"
                      justifyContent={{
                        xs: 'flex-start',
                        sm: 'center',
                        md: 'flex-start',
                      }}
                    >
                      <img
                        src="/assets/images/irs-authorized.png"
                        alt="IRS-Authorized"
                        className="banner-icon"
                        width={32}
                        height={32}
                      />
                      <Typography
                        sx={{
                          color: '#14181F',
                          fontSize: { xs: 15, sm: 13, md: 14, lg: 15 },
                          fontWeight: 500,
                        }}
                      >
                        IRS Authorized E-File Provide
                      </Typography>
                    </Stack>{' '}
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent={{
                        xs: 'flex-start',
                        sm: 'center',
                        md: 'flex-start',
                      }}
                    >
                      <img
                        src="/assets/images/secure-new-icon.png"
                        alt="99% Acceptance rate"
                        className="banner-icon"
                        width={32}
                        height={32}
                      />
                      <Typography
                        sx={{
                          color: '#14181F',
                          fontSize: { xs: 15, sm: 13, md: 14, lg: 15 },
                          fontWeight: 500,
                        }}
                      >
                        100% Secure Filing
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent={{
                        xs: 'flex-start',
                        sm: 'center',
                        md: 'flex-start',
                      }}
                    >
                      <img
                        src="/assets/images/instant-icon-new.png"
                        alt="Receive instant update"
                        className="banner-icon"
                        width={32}
                        height={32}
                      />
                      <Typography
                        sx={{
                          color: '#14181F',
                          fontSize: { xs: 15, sm: 13, md: 14, lg: 15 },
                          fontWeight: 500,
                        }}
                      >
                        Instant IRS Acknowledgment
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                    <Stack
                      direction={{ xs: 'row', sm: 'row' }}
                      spacing={1}
                      alignItems="center"
                      justifyContent={{
                        xs: 'flex-start',
                        sm: 'center',
                        md: 'flex-start',
                      }}
                    >
                      <img
                        src="/assets/images/rate-icon.png"
                        alt="Free Retransmission on Rejection"
                        className="banner-icon"
                        width={32}
                        height={32}
                      />
                      <Typography
                        sx={{
                          color: '#14181F',
                          fontSize: { xs: 15, sm: 13, md: 14, lg: 15 },
                          fontWeight: 500,
                        }}
                      >
                        Free Retransmission on Rejection
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg" sx={{ mb: 5, px: 0 }}>
        <Box
          sx={{
            width: '100%',
            maxWidth: '1200px',
            mx: 'auto',
            backgroundColor: '#fff',
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Information You Can Carry Forward from
                <br />
                Prior-Year Form 990 Returns
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                  width: { xs: '100%', sm: '80%', md: '80%', lg: '80%' },
                  mx: 'auto',
                }}
              >
                Our system automatically carries forward eligible information
                from your prior-year return, and you can review and import
                additional details as needed.
              </Typography>
            </Grid>
          </Grid>

          <Box
            sx={{
              display: 'flex',
            }}
          >
            {/* LEFT VERTICAL TABS */}

            <Box
              sx={{
                maxWidth: 180,
                position: 'sticky',
                top: 90,
                border: '1px solid #ccc',
                mt: '24px !important',
                borderRadius: 2,
                boxShadow: '0 0 10px rgba(0,0,0,.10)',
                backgroundColor: 'rgba(255, 255, 255, 0.85)',
              }}
            >
              <Tabs
                orientation="vertical"
                value={activeTab}
                onChange={handleChange}
                sx={{
                  textAlign: 'left',
                  justifyContent: 'center',
                  py: 1,
                }}
                className="faq-container"
              >
                {/* 990-N */}
                <Tab
                  label={
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 'inherit',
                          fontWeight: 'inherit',
                          textAlign: 'left',
                        }}
                      >
                        Form 990
                      </Typography>
                    </Box>
                  }
                />

                {/* 990-EZ */}
                <Tab
                  label={
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 'inherit',
                          fontWeight: 'inherit',
                        }}
                      >
                        Form 990-EZ
                      </Typography>
                    </Box>
                  }
                />

                {/* 990 */}
                <Tab
                  label={
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 'inherit',
                          fontWeight: 'inherit',
                        }}
                      >
                        Form 990-PF
                      </Typography>
                    </Box>
                  }
                />
              </Tabs>
            </Box>

            {/* RIGHT CONTENT */}

            <Box
              sx={{
                flex: 1,
                px: {
                  xs: 3,
                  sm: 4,
                  md: 5,
                },
                py: {
                  xs: 2,
                  sm: 3,
                  md: 4,
                },
              }}
            >
              {/* =================================================
              TAB 0 — 990-N
          ================================================= */}

              {activeTab === 0 && (
                <Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: '20px',
                        sm: '23px',
                        md: '27px',
                      },
                      fontWeight: 700,
                      color: '#17283f',
                      mb: 2,
                    }}
                  >
                    Form 990
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.2,
                    }}
                  >
                    {/* 1 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Organization details, including legal name, address,
                        organizational structure, mission statement, and
                        bookkeeping information.
                      </Typography>
                    </Box>

                    {/* 2 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Information on Officers, Directors, Trustees, Key
                        Employees, and Highest Compensated Employees.
                      </Typography>
                    </Box>

                    {/* 3 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year asset reporting and financial position
                        details.
                      </Typography>
                    </Box>

                    {/* 4 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year liability reporting and outstanding
                        obligation details.
                      </Typography>
                    </Box>

                    {/* 5 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Public charity classification and tax-exempt status
                        information.
                      </Typography>
                    </Box>

                    {/* 6 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year public support calculations and funding
                        sources.
                      </Typography>
                    </Box>

                    {/* 7 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Authorized signer and filing authority details for
                        compliance purposes.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}

              {/* TAB 1 — 990-EZ */}

              {activeTab === 1 && (
                <Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: '20px',
                        sm: '23px',
                        md: '27px',
                      },
                      fontWeight: 700,
                      color: '#17283f',
                      mb: 2,
                    }}
                  >
                    Form 990-EZ?
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.2,
                    }}
                  >
                    {/* 1 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Organization details, including legal name, address,
                        organizational structure, mission statement, and
                        bookkeeping information.
                      </Typography>
                    </Box>

                    {/* 2 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Information on Officers, Directors, Trustees, Key
                        Employees, and Highest Compensated Employees.
                      </Typography>
                    </Box>

                    {/* 3 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year asset reporting and financial position
                        details.
                      </Typography>
                    </Box>

                    {/* 4 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year liability reporting and outstanding
                        obligation details.
                      </Typography>
                    </Box>

                    {/* 5 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Public charity classification and tax-exempt status
                        information.
                      </Typography>
                    </Box>

                    {/* 6 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year public support calculations and funding
                        sources (if Schedule A is required).
                      </Typography>
                    </Box>

                    {/* 7 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Authorized signer and filing authority details for
                        compliance purposes.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}

              {/* =================================================
              TAB 2 — 990
          ================================================= */}

              {activeTab === 2 && (
                <Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: '20px',
                        sm: '23px',
                        md: '27px',
                      },
                      fontWeight: 700,
                      color: '#17283f',
                      mb: 2,
                    }}
                  >
                    Form 990-PF
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.2,
                    }}
                  >
                    {/* 1 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Foundation details, including legal name, address,
                        accounting method, organizational information, and
                        bookkeeping details.
                      </Typography>
                    </Box>

                    {/* 2 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Information on Officers, Directors, Trustees, Foundation
                        Managers, and compensation details.
                      </Typography>
                    </Box>

                    {/* 3 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year asset reporting, including investment assets,
                        charitable-use assets, and financial position details.
                      </Typography>
                    </Box>

                    {/* 4 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year liability reporting and outstanding
                        obligations.
                      </Typography>
                    </Box>

                    {/* 5 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Foundation classification, private foundation status,
                        and tax-exempt information.
                      </Typography>
                    </Box>

                    {/* 6 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Prior-year charitable distributions, qualifying
                        distributions, grants, and investment income details.
                      </Typography>
                    </Box>

                    {/* 7 */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.2,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: '#20a957',
                          fontSize: 20,
                          mt: '3px',
                          flexShrink: 0,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: {
                            xs: '14px',
                            sm: '15px',
                            md: '16px',
                          },
                          lineHeight: 1.45,
                          color: '#17283f',
                        }}
                      >
                        Authorized signer and filing{' '}
                        <Box
                          component="span"
                          sx={{
                            textDecoration: 'underline',
                          }}
                        >
                          authority
                        </Box>{' '}
                        details for compliance purposes.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Container>

      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  mr: { xs: 0, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/what-is-form-w9-img.webp" />
                  <source srcSet="/assets/images/what-is-form-w9-img.png" />
                  <img
                    src="/assets/images/what-is-form-w9-img.png"
                    alt="What is Form W-9?"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={380}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is IRS2File?
                </Typography>

                <List
                  sx={{
                    display: 'inline-block',
                    mb: 2,
                  }}
                >
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -9 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      IRS2File is a smart and convenient way to begin your tax
                      filing process without having to enter all your
                      information manually. It securely retrieves the required
                      information from IRS records, making the filing process
                      faster, simpler, and less overwhelming.
                    </ListItemText>
                  </ListItem>

                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -15 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Organization details are usually quick to enter, but
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        prior-year financial information - like revenue,
                        expenses, and assets{' '}
                      </span>{' '}
                      is a different story. Tracking it down takes time and is
                      where most filing errors happen. That's the exact gap
                      IRS2File fills, pulling this{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        financial data forward{' '}
                      </span>{' '}
                      automatically, so accuracy isn't left to guesswork.
                    </ListItemText>
                  </ListItem>

                  <ListItem disablePadding>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -3 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      This saves time, minimizes errors, and ensures a smooth
                      filing experience from start to finish.
                    </ListItemText>
                  </ListItem>
                </List>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Why Use IRS2File?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Manually entering organization information can be
                  time-consuming and may lead to errors. IRS2File simplifies the
                  process by automatically importing available IRS data into
                  your return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Benefits of IRS2File :
                </Typography>

                <List
                  sx={{
                    display: 'inline-block',
                    mb: 2,
                  }}
                >
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Carry forward financial information from your prior-year
                      return
                    </ListItemText>
                  </ListItem>

                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Save time during return preparation
                    </ListItemText>
                  </ListItem>

                  <ListItem disablePadding>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>Reduce manual data entry</ListItemText>
                  </ListItem>

                  <ListItem disablePadding>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>Minimize filing errors </ListItemText>
                  </ListItem>

                  <ListItem disablePadding>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Review imported information before filing
                    </ListItemText>
                  </ListItem>

                  <ListItem disablePadding>
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText>
                      Enjoy a faster and smoother filing experience
                    </ListItemText>
                  </ListItem>
                </List>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  mr: { xs: 0, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/what-is-form-w9-img.webp" />
                  <source srcSet="/assets/images/what-is-form-w9-img.png" />
                  <img
                    src="/assets/images/what-is-form-w9-img.png"
                    alt="What is Form W-9?"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={380}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Start Filing Faster with IRS2File
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Automatically import available IRS data and reduce manual entry,
                helping you complete your return more efficiently.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <img
                    src="/assets/images/7004-icon.svg"
                    alt="Form 7004"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Form 990-EZ
                </Typography>
                <Typography variant="body1">
                  IRS2File automatically imports available IRS organization
                  information to help eligible nonprofits begin their IRS Form
                  990-EZ filing quickly and accurately.
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button
                    size="large"
                    variant="contained"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    sx={{
                      boxShadow: 'none',
                      borderRadius: 3,
                      textTransform: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                  >
                    File Form 990-EZ Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <img
                    src="/assets/images/4868-icon.svg"
                    alt="Form 4868"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Form 990
                </Typography>
                <Typography variant="body1">
                  Save time to file Form 990 by importing available IRS data.
                  Review your information, make updates if needed, and continue
                  with confidence
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button
                    size="large"
                    variant="contained"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    sx={{
                      boxShadow: 'none',
                      borderRadius: 3,
                      textTransform: 'none',
                      backgroundColor: '#1da94a',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        backgroundColor: '#1a7738',
                        transform: 'scale(1.1)',
                      },
                    }}
                  >
                    File Form 990 Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <img
                    src="/assets/images/8868-icon.svg"
                    alt="Form 8868"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Form 990-PF
                </Typography>
                <Typography variant="body1">
                  Private foundations can use IRS2File to retrieve available IRS
                  information and simplify the initial stages of IRS Form 990-PF
                  preparation.
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button
                    size="large"
                    variant="contained"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    sx={{
                      boxShadow: 'none',
                      borderRadius: 3,
                      textTransform: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                  >
                    File Form 990-PF Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Why we built this feature
                </Typography>
                <List
                  sx={{
                    display: 'inline-block',
                    mb: 2,
                  }}
                >
                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>1.Save time:</span>{' '}
                          Skip repetitive data entry and complete your return
                          faster.
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            2.Reduce errors:{' '}
                          </span>{' '}
                          Use verified IRS data to minimize mistakes and
                          inconsistencies.
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            3.Improve clarity:
                          </span>{' '}
                          Pre-filled information helps you better understand
                          your filing.
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            4.Simplify the process:
                          </span>{' '}
                          Designed for users who want a smooth, guided
                          experience.
                        </>
                      }
                    />
                  </ListItem>

                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            5.Carry forward past return data:
                          </span>{' '}
                          Automatically carry forward eligible revenue,
                          expenses, and asset information from your prior
                          filing.
                        </>
                      }
                    />
                  </ListItem>
                </List>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{
                    mb: 2,
                    fontSize: 13,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                  }}
                >
                  <b> Note:</b> Your data is handled with strict security and
                  privacy standards, ensuring that your information remains
                  protected at every step.
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  mr: { xs: 0, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/what-is-form-w9-img.webp" />
                  <source srcSet="/assets/images/what-is-form-w9-img.png" />
                  <img
                    src="/assets/images/what-is-form-w9-img.png"
                    alt="What is Form W-9?"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={380}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 3,
                  border: 'none',
                  maxWidth: 950,
                  m: 'auto',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Why Choose TaxZerone to File Your Return
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  TaxZerone makes tax filing faster, smarter, and more accurate
                  by eliminating manual work and simplifying every step of the
                  process. With secure IRS data import and intelligent pre-fill
                  capabilities, you can focus on review and not re-entering your
                  information.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 1, fontWeight: 600, fontStyle: 'italic' }}
                >
                  Here’s what you get with TaxZerone:
                </Typography>

                <List>
                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Direct IRS data import
                          </span>{' '}
                          to auto-populate your return with available
                          organization details
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Faster filing experience
                          </span>{' '}
                          with reduced manual data entry and repetitive work
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Secure data protection
                          </span>{' '}
                          through encrypted information handling
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Simplified review process
                          </span>{' '}
                          so you can verify and proceed with confidence
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem
                    disablePadding
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#1da94a' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontWeight: 600 }}>
                            Streamlined workflow
                          </span>{' '}
                          designed specifically for nonprofit tax filing needs
                        </>
                      }
                    />
                  </ListItem>
                </List>

                <Typography variant="body1">
                  Instead of starting from scratch, TaxZerone helps you move
                  forward with clarity, speed, and confidence.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 1 },
                }}
              >
                Hear What Our Clients Say About Us
              </Typography>

              <Grid
                container
                spacing={2}
                m={0}
                justifyContent="center"
                direction="row"
                className="MuiGrid-root-width"
                sx={{ mb: 3 }}
              >
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#ffffff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                      minHeight={{ xs: 'auto', sm: 'auto', md: 200, lg: 200 }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        The IRS2File feature worked exactly as expected. It
                        saved me from entering everything manually, and the
                        filing process was smooth from start to finish. Thanks
                        TaxZerone
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      - Kathy Pinke
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#ffffff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                      minHeight={{ xs: 'auto', sm: 'auto', md: 200, lg: 200 }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I really liked the IRS2File feature. It imported my
                        information accurately, reduced manual work, and helped
                        me file with confidence.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      - Fernando Gonzalez
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#ffffff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                      minHeight={{ xs: 'auto', sm: 'auto', md: 200, lg: 200 }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        Most of my IRS information was already pre-filled. I
                        reviewed the remaining details and filed with
                        confidence.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      - Alejandra Sagissor
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Which IRS forms can I file using IRS2File
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    You can file major exempt organization forms including Form
                    990, 990-EZ, and Form 990-PF, along with extensions and
                    supporting compliance forms depending on eligibility.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Is my data secure with IRS2File?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography>
                      Absolutely.IRS2File uses secure encryption and
                      compliance-grade safeguards to protect all sensitive
                      organizational and financial data throughout the filing
                      process.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Can I review my imported information before filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    Yes. After your information is imported, you can review
                    every section, edit any prefilled details, and make updates
                    as needed before submitting your return. This helps ensure
                    your filing is complete and accurate.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Irs2File;
